import { render, staticRenderFns } from "./NoPageList.vue?vue&type=template&id=076beadd&scoped=true&"
import script from "./NoPageList.vue?vue&type=script&lang=js&"
export * from "./NoPageList.vue?vue&type=script&lang=js&"
import style0 from "./NoPageList.vue?vue&type=style&index=0&id=076beadd&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076beadd",
  null
  
)

export default component.exports